<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title" v-if="filter.datasources == 1">门诊复诊统计</label>

				<label class="title" v-else>出院复诊统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>| <span>效果统计</span>|
					<span v-if="filter.datasources == 1">门诊复诊统计</span>
					<span v-else>出院复诊统计</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>{{
							{ 1: '就诊', 2: '出院' }[filter.datasources]
						}}日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>预约复诊日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date2"
								:picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<label>实际复诊日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date3"
								:picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
					</div>
					<div class="def-key">
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i
								class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>
			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">


					<el-table-column label="科室" width="280">
						<template slot-scope="scope">
							<router-link class="noline"
								:to="{ name: 'Statistics/Manage', query: { depId: scope.row.depId, datasources: filter.datasources, type: 2, date: getFormattedDateForQuery() } }">
								<span class="fc key">{{ scope.row.depName }}</span>
							</router-link>
						</template>
					</el-table-column>

					<el-table-column prop="totalNumbers"
						:label="filter.datasources == 1 ? '就诊总人次' : '出院总人次'"></el-table-column>
					<el-table-column prop="returnVisitTotal" label="预约复诊人次"></el-table-column>
					<el-table-column>
						<template slot="header">
							预约率
							<img @click="openModal('header')" class="t-img" src="../../assets/images/question-fill.png"
								alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.reservationRate }}</span>
							<img @click="openModal('column', scope.row)" class="t-img"
								src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<CustomTableColumn prop="toBeTotal" label="未到复诊时间" routeName="Subsequent/Common"
						:datasources="filter.datasources"
						:extraQueryParams="{ date: filter.date2, date2: filter.date, status: 1 }"></CustomTableColumn>
					<CustomTableColumn prop="actualTotal" label="已复诊人次" routeName="Subsequent/Common"
						:datasources="filter.datasources"
						:extraQueryParams="{ date: filter.date2, date2: filter.date, status: 2 }"></CustomTableColumn>
					<CustomTableColumn prop="nonPerformanceTotal" label="未履约人次" routeName="Subsequent/Common"
						:datasources="filter.datasources"
						:extraQueryParams="{ date: filter.date2, date2: filter.date, status: 3 }">
					</CustomTableColumn>
					<el-table-column>
						<template slot="header">
							履约率
							<img @click="openModal('header1')" class="t-img" src="../../assets/images/question-fill.png"
								alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.agreementRate }}</span>
							<img @click="openModal('column1', scope.row)" class="t-img"
								src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<!-- <el-table-column
            prop="returnVisitRate"
            label="复诊率"
          ></el-table-column> -->
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">
								当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span v-text="(filter.pageNumber - 1) * filter.pageSize + filter.pageSize
									"></span>数据
							</div>
							<div class="record">
								总计<span v-text="list.total"></span>条记录
							</div>
						</el-col>
						<el-col :span="12" style="text-align: right">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />
	</div>
</template>

<script>
import api from "@/service/api.js";
import mixin from "@/views/mixin";
import dayjs from "dayjs";
import ModalCommon from './components/modalCommon.vue';
import questionFillImg from '@/assets/images/question-fill.png';
import CustomTableColumn from './components/tableColumn.vue';

export default {
	mixins: [mixin],
	components: { ModalCommon, CustomTableColumn },

	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null,
				summary: [],
			},
			filter: {
				datasources: 0,
				outHospitalTimeStart: "",
				outHospitalTimeEnd: "",
				appointmentTimeStart: "",
				appointmentTimeEnd: "",
				returnVisitDateStart: '',
				returnVisitDateEnd: '',
				depId: "",
				orgId: '',
				pageNumber: 1,
				pageSize: 10,
				date: [],
				date3: []
			},
			deptList: [],
			permission: false,
			orgList: [],
			dlg: {
				visible: false,
				type: '',
				propname: 'return',
				data: {},
			},
		};
	},
	created() {
		let query = this.$route.query;
		this.filter.datasources = query.datasources;
		const now = dayjs();
		const firstDayOfMonth = dayjs().startOf('month');
		this.$watch(
			() => this.$route.query, // 监听的对象是 $route.query
			(newQuery, oldQuery) => {
				this.filter = {
					datasources: newQuery.datasources,
					outHospitalTimeStart: firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss'),
					outHospitalTimeEnd: now.format('YYYY-MM-DD HH:mm:ss'),
					appointmentTimeStart: "",
					appointmentTimeEnd: "",
					depId: "",
					orgId: '',
					pageNumber: 1,
					pageSize: 10,
					date: [this.filter.outHospitalTimeStart, this.filter.outHospitalTimeEnd]
				}
				this.$set(this.filter, 'date', [this.filter.outHospitalTimeStart, this.filter.outHospitalTimeEnd]);
				this.loadList();
			}
		);
		// 获取 科室下拉
		api.getDeptDropdown({
			departmentType: this.filter.datasources == 1 ? 1 : 0
		}).then((res) => {
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		});
		// 获取机构下拉
		api.getListComboboxOrg().then((res) => {
			if (res.code == 1000) {
				this.orgList = res.data;
			} else {
				this.$message.error(res.message)
			}
		})

	},
	mounted() {
		const now = dayjs();
		const firstDayOfMonth = dayjs().startOf('month');
		this.filter.outHospitalTimeStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
		this.filter.outHospitalTimeEnd = now.format('YYYY-MM-DD HH:mm:ss');
		this.filter.date = [this.filter.outHospitalTimeStart, this.filter.outHospitalTimeEnd];
		this.loadList();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getReturnVisitReport(this.filter);
			if (res.code == 500) {
				return this.$router.push({
					name: "Login",
					query: {
						r: location.href
					},
				});
			}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.code == 1000 && res.data) {
				this.list.summary = [
					"合计",
					res.data.sum.totalNumbers,
					res.data.sum.returnVisitTotal,
					res.data.sum.reservationRate,
					res.data.sum.toBeTotal,
					res.data.sum.actualTotal,
					res.data.sum.nonPerformanceTotal,
					res.data.sum.agreementRate,
					res.data.sum.returnVisitRate,
				];
				this.list.data = res.data.list;
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "9") ? true : false;
			this.isLoading = false;
		},
		getSummaries() {
			if (this.$refs['multipleTable']) {
				let current = this.$refs['multipleTable']
				let tbodyElement = current.$el.querySelector('tbody.has-gutter');
				if (tbodyElement) {
					let trElements = tbodyElement.querySelectorAll('tr');
					let img1 = document.querySelector('.img1');
					let img2 = document.querySelector('.img2');
					trElements.forEach(tr => {
						let tdElements = tr.querySelectorAll('td');
						tdElements.forEach((td, index) => {
							let divElement = td.querySelector('.cell');

							if (divElement && !(img1 || img2) && (index == 3 || index == 7)) {
								let imgElement = document.createElement('img');
								imgElement.src = questionFillImg;

								if (index == 3) {
									imgElement.className = 'img1';
									imgElement.addEventListener('click', () => this.openSumModal('column'));
								} else if (index == 7) {
									imgElement.className = 'img2';
									imgElement.addEventListener('click', () => this.openSumModal('column1'));
								}
								divElement.appendChild(imgElement);
							}
						});

					});
				} else {
					console.error('无法找到<tbody>元素！');
				}
			}
			this.$nextTick(() => {
				this.$refs['multipleTable'].doLayout();
			});
			return this.list.summary;
		},
		openSumModal(type) {
			this.dlg.type = type;
			if (type == 'column') {
				this.dlg.data.reservationRate = this.list.summary[3]
				this.dlg.data.returnVisitTotal = this.list.summary[2]
				this.dlg.data.totalNumbers = this.list.summary[1]
			} else if (type == 'column1') {
				this.dlg.data.agreementRate = this.list.summary[7]
				this.dlg.data.actualTotal = this.list.summary[5]
				this.dlg.data.returnVisitTotal = this.list.summary[2]
				this.dlg.data.toBeTotal = this.list.summary[4]
			}
			this.dlg.visible = true;
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch (key) {
				case 0:
					if (this.filter.date) {
						this.filter.outHospitalTimeStart = dayjs(
							this.filter.date[0]
						).format("YYYY-MM-DD 00:00:00");
						this.filter.outHospitalTimeEnd = dayjs(this.filter.date[1]).format(
							"YYYY-MM-DD 23:59:59"
						);
					} else {
						this.filter.outHospitalTimeStart = "";
						this.filter.outHospitalTimeEnd = "";
					}
					break;
				case 2:
					if (this.filter.date2) {
						this.filter.appointmentTimeStart = dayjs(
							this.filter.date2[0]
						).format("YYYY-MM-DD 00:00:00");
						this.filter.appointmentTimeEnd = dayjs(this.filter.date2[1]).format(
							"YYYY-MM-DD 23:59:59"
						);
					} else {
						this.filter.appointmentTimeStart = "";
						this.filter.appointmentTimeEnd = "";
					}
					break;
				case 3:
					if (this.filter.date3) {
						this.filter.returnVisitDateStart = dayjs(
							this.filter.date3[0]
						).format("YYYY-MM-DD 00:00:00");
						this.filter.returnVisitDateEnd = dayjs(this.filter.date3[1]).format(
							"YYYY-MM-DD 23:59:59"
						);
					} else {
						this.filter.returnVisitDateStart = "";
						this.filter.returnVisitDateEnd = "";
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize = this.list.total;
			let url = api.exportStatisticReturnVisitReport(this.filter);
			const tempLink = document.createElement("a");
			tempLink.style.display = "none";
			tempLink.href = url;
			tempLink.target = "_blank";
			document.body.appendChild(tempLink);
			tempLink.click();
			document.body.removeChild(tempLink);
			this.filter.pageSize = 10;

		},
		openModal(type, data) {
			this.dlg.data = data;
			this.dlg.type = type;
			this.dlg.visible = true;
		},
		// 格式化日期用于查询参数传递
		getFormattedDateForQuery() {
			if (this.filter.date && this.filter.date.length === 2) {
				return [
					dayjs(this.filter.date[0]).format('YYYY-MM-DD'),
					dayjs(this.filter.date[1]).format('YYYY-MM-DD')
				];
			}
			return [];
		}
	},
};
</script>

<style lang="less" scoped>
@import "@/assets/style/var";
@import './components/sty.less';
</style>